/*
 * @Author       : Zhelin Cheng
 * @Date         : 2021-11-05 14:51:59
 * @LastEditors  : 程哲林
 * @LastEditTime : 2024-03-11 13:48:18
 * @FilePath     : /marketing-introduce-ssr/utils/request.ts
 * @Description  : 未添加文件描述
 */

import * as Sentry from '@sentry/nextjs';
import axios, { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import {
  AUTH_SIGN_URL,
  DEBUG_HEADER_INFO,
  isBrowser,
  isJoJoUp,
  TINMAN_BASE_C_URL,
  TINMAN_BASE_URL
  // AUTH_SIGN_URL_NEW,
} from 'common/const';
import Cookies from 'js-cookie';
import Router from 'next/router';
import QS from 'querystring';

import { isJoJoBrowser } from '.';
// import WeChatAuth from '@/components/Activity/WeChatAuth'
import { jojoAppDirectLogin } from './bridge';
// import { sensClickInitiative, sensElementView } from './sensors'
import { CustomError } from './sentry';
// import { getApolloConfig } from '@/services/activity'

const NOT_REPORT_API = ['flagd.evaluation.v1.Service/Resolve'];

function shouldReportApi(url: string = ''): boolean {
  return !NOT_REPORT_API.some((api) => url?.includes(api));
}

// 过滤掉常见的网络错误，避免过度上报
const ignoreErrors = ['Request aborted', 'Network Error', 'timeout of', 'Network request failed'];

const isJoJoApp = isJoJoBrowser();

const TMUserAgent: any =
  isBrowser && Cookies.get('authToken')
    ? {
        'TM-UserAgent-appUserAuthToken': Cookies.get('authToken') || '',
        'TM-UserAgent-deviceUniqueIdentifier': Cookies.get('deviceId') || '',
        'TM-UserAgent-appBundleIdentifier': Cookies.get('packageName') || ''
      }
    : {};

// 超时配置
// sentry错误：timeout of 8000ms exceeded
axios.defaults.timeout = 30000;

const _JOJO_BASE_URL = process.env.ENV_MOCK
  ? 'https://mock.xjjj.co/mock/6189053a6d57c80a2031851c/mall-boom/api/boom'
  : `${isBrowser ? TINMAN_BASE_C_URL : TINMAN_BASE_URL}/api/boom`;
const _JOJOUP_BASE_URL = `${TINMAN_BASE_C_URL}/mall/boom/api/boom`;
const _BASE_URL = isJoJoUp ? _JOJOUP_BASE_URL : _JOJO_BASE_URL;

axios.defaults.baseURL = _BASE_URL;

axios.defaults.headers.common = isBrowser
  ? {
      ...TMUserAgent,
      ...((DEBUG_HEADER_INFO as any) || {})
    }
  : {};

axios.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    return config;
  },
  (error: AxiosError) => {
    return Promise.reject(error);
  }
);

const timeout = (time: number) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(true);
    }, time);
  });
};

export async function login(appid = '', linkUrl?: string, sceneParams?: any) {
  const { protocol, host, pathname, search, href } = window.location;
  const dUrl = __store?.actPageIndex
    ? [protocol, '//', host, pathname].join('').replace(/\/([^/]\d*)$/, search)
    : href;
  // const splice = search ? '&' : '?'
  const authWechatAppId = appid ? `&authWechatAppId=${appid}` : '';
  /*  const res = await getApolloConfig({
    key: 'uc.use.newLogin'
  }) */

  // const res = { data: false }

  let requestUrl = linkUrl || dUrl;

  if (sceneParams) {
    requestUrl += `${requestUrl?.includes('?') ? '&' : '?'}${QS.stringify(sceneParams)}`;
  }
  const redirectUrl = [
    AUTH_SIGN_URL,
    '?authMode=1',
    authWechatAppId,
    '&requestUrl=',
    encodeURIComponent(requestUrl)
  ].join('');

  window.location.replace(redirectUrl);

  // 该操作是为了跳转到登录页不报错
  await timeout(10 * 1000);
  /* WeChatAuth.show({
    authURL: redirectUrl,
    onShow: () => {
      sensElementView({
        c_element_name: '运营活动页_登录提示弹窗',
      })
    },
    onAgree: () => {
      sensClickInitiative({
        $element_name: '运营活动页_登录提示弹窗_同意并继续',
      })
    },
    onClose: () => {
      sensClickInitiative({
        $element_name: '运营活动页_登录提示弹窗_拒绝并退出',
      })
      if (window.wx) {
        wx?.closeWindow()
      }
      WeChatAuth.hide()
    },
  }) */
}

let jumpAuthStatus = false;
axios.interceptors.response.use(
  async (response: AxiosResponse) => {
    const { status, config, data }: any = response;
    if (!(status >= 200 || status < 300)) {
      return Promise.reject(response);
    }

    const code = data?.code || data.status || data?.resultCode;
    const isSuccess = code === 'SUCCESS' || code === 200;

    // 错误信息上报
    if (!isSuccess && ![1001, 1005].includes(code)) {
      if (shouldReportApi(config?.url || '')) {
        const err = new CustomError({
          name: '接口错误',
          message: data?.errorMsg || data?.message || '接口请求错误'
        });
        Sentry.captureException(err, {
          level: Sentry.Severity.Warning,
          extra: {
            error: '接口请求错误',
            environment: isBrowser ? 'browser' : 'node',
            url: config.url,
            baseUrl: config.baseURL,
            params: config.params,
            data: config.data,
            response: response?.data
          }
        });
      }
    }

    // 用户需要登录
    if (isBrowser && [1001, 1005].includes(code) && !config.enforcement) {
      if (isJoJoApp) {
        if (jumpAuthStatus) {
          return Promise.resolve(response);
        }

        jumpAuthStatus = true;

        jojoAppDirectLogin('', () => {
          jumpAuthStatus = false;
        });

        return Promise.resolve(response);
      }
      await login(data.authWechatAppId, undefined, config?.sceneParams);
      // window.location.replace(redirectUrl)
    }

    return Promise.resolve(response);
  },
  (error: AxiosError) => {
    const { config = {} } = error;
    if (shouldReportApi(config?.url || '')) {
      const shouldIgnore = ignoreErrors.some((ignore) => error?.message?.includes(ignore));
      if (!shouldIgnore) {
        const sentryError = new CustomError({
          name: '接口错误',
          message: error?.message || '接口请求错误'
        });
        Sentry.captureException(sentryError, {
          level: Sentry.Severity.Warning,
          extra: {
            error: '接口请求错误',
            environment: isBrowser ? 'browser' : 'node',
            url: config.url,
            baseUrl: config.baseURL,
            params: config.params,
            data: config.data,
            response: error?.response || error
          }
        });
      }
    }

    return Promise.reject(error);
  }
);

type AuthType = 'wx' | 'jojoApp' | 'miniApp' | 'other';
// let platform: AuthType | null = null
let isLogin: boolean | null = null;

if (isBrowser) {
  if (isLogin === null) {
    //! CHECK 新增本地模式
    isLogin = Boolean(Cookies.get('uid')) || !!DEBUG_HEADER_INFO['X-UAGW-userId'];
  }

  Router.events.on('routeChangeStart', () => {
    if (
      // 必须是首页
      __store.actPageIndex &&
      // 必须是未登录状态
      !__store.isLogin /* &&
      !/^\/activity\/.*\/\d+$/.test(path) */
    ) {
      login();
      throw new Error(
        `routeChange aborted. This error can be safely ignored - https://github.com/zeit/next.js/issues/2476.`
      );
    }
  });

  // 拦截所有跳转
  document.addEventListener('click', (e: any) => {
    if (
      // 必须是首页
      __store.actPageIndex &&
      // 必须是未登录状态
      !__store.isLogin
    ) {
      let target = e?.target;
      if (target?.tagName === 'IMG') {
        const { dataset } = target || {};
        if (dataset.isposter === '1') {
          target = target?.parentNode;
        }
      }
      if (target?.tagName === 'A') {
        e.preventDefault();
        const dataSet = target?.dataset;
        const reloadType = dataSet?.reloadtype;
        const sceneParams = reloadType ? { scene: 'BtnClick', btnReloadType: reloadType } : null;
        login('', '', sceneParams);
      }
    }
  });

  /* getCurrPlatform().then((idx) => {
    platform = ['jojoApp', 'wx', 'miniApp', 'other'][idx] as AuthType
  }) */
}

export const rq = async function <DataType = any>(
  cfg: AxiosRequestConfig & {
    prefix?: string;
    authPrefix?: string;
    authPlatform?: AuthType[] | 'auto';
    enforcement?: boolean;
    sceneParams?: {
      scene: string;
      [key: string]: any;
    };
  }
): Promise<DataType> {
  const config = cfg;
  // const authArr = config.authPlatform || []
  const baseUrl = config.baseURL || _BASE_URL;
  const userLogin = __store.isLogin || isLogin;
  if (
    // __store.actPageIndex &&
    userLogin &&
    config.authPrefix
    // authArr.includes(platform as AuthType)
  ) {
    config.baseURL = baseUrl + config.authPrefix;
  } else {
    config.baseURL = baseUrl + (config.prefix || '');
  }
  const { data }: AxiosResponse<DataType> = await axios(config);
  return data;
};

export async function getApi<T>(url: string, params?: any, headers?: any): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url,
    params,
    headers
  });
}

export async function postApi<T>(url: string, data?: any, sceneParams?: any): Promise<RespType<T>> {
  return rq<RespType<T>>({
    url,
    method: 'POST',
    data,
    sceneParams
  });
}
